import React ,{ useContext }from 'react';
import Button from 'react-bootstrap/Button';
import { Link} from 'react-router-dom';
import Form from 'react-bootstrap/Form'; 
import { useNavigate } from 'react-router-dom'
import { CheckPopUpContext } from '../components/DataContext';
import canal1 from "../images/canal1.jpeg";
import cerrar from "../images/cerrar.png";
import Autorización_Tratamiento_de_datos_personales_v3 from '../files/Autorización_Tratamiento_de_datos_personales_v3.pdf';
import Header from "../components/Header";
import { Helmet } from "react-helmet-async";

export const IncioSICOF = () => {
    
    const checkPopUpContext = useContext(CheckPopUpContext);
    const {opcionSeleccionadaPopUp1, setOpcionSeleccionadaPopUp1 } = checkPopUpContext;

    const checkPopUpContext1 = useContext(CheckPopUpContext);
    const { opcionSeleccionadaPopUp2, setOpcionSeleccionadaPopUp2 } = checkPopUpContext1;

    const OcultarPopUpRegistrarDenuncia = document.getElementById("PopUpRegistraDenuncia");
    const navigate = useNavigate();

    //Validacion Check PopUpDatosPersonales
    const handleSeleccionPopUp1 = (opcion) => {
        const ButtonSiguientePopUp = document.getElementById("SiguientePopUp");
        const CheckAutorizarData = document.getElementById("checkboxAutorizarData");
        const LabelCheckAutorizarData = document.getElementById("labelColor");
        const advertenciaLabel = document.getElementById("LecturaChecks");

        setOpcionSeleccionadaPopUp1(opcion);
        if(opcion === true){
            ButtonSiguientePopUp.style.display='block';

            //Parte Advertebcia label PopUpRegistraDenunucia
            advertenciaLabel.style.display= 'none'
            
            //Parte del Check PopUpDatosPersonales
            CheckAutorizarData.style.backgroundColor = '#009400';
            CheckAutorizarData.style.border = '1px solid green';
            LabelCheckAutorizarData.style.color = 'green';
        }
        else{
            ButtonSiguientePopUp.style.display='none';

            //Parte Advertebcia label PopUpRegistraDenunucia
            advertenciaLabel.style.display= 'block'

            //Parte label PopUpRegistraDenunucia
            CheckAutorizarData.style.backgroundColor = '#fc9989';
            CheckAutorizarData.style.border = '1px solid red';
            LabelCheckAutorizarData.style.color = 'red';
        }
    }
    
    //Oncick Button Siguiente registrarDenuncia
    const PopUpDatosPersonales = () => {
        const ButtonSiguientePopUp = document.getElementById("SiguientePopUp");
        const CheckAutorizarData = document.getElementById("checkboxAutorizarData")
        const LabelCheckAutorizarData = document.getElementById("labelColor");
        if (opcionSeleccionadaPopUp1 === true) {

            //Parte Para Mostrar el PopUpRegistraDenunucia
            const MostrarPopUpDatosPersonales = document.getElementById("PopUpRegistraDenuncia");
            MostrarPopUpDatosPersonales.style.display = 'flex';
            MostrarPopUpDatosPersonales.style.flexDirection = 'row';
            MostrarPopUpDatosPersonales.style.position = 'absolute';
            MostrarPopUpDatosPersonales.style.flexWrap = 'wrap'; 
            MostrarPopUpDatosPersonales.style.alignItems = 'baseline'; 
            MostrarPopUpDatosPersonales.style.justifyContent = 'baseline';
            MostrarPopUpDatosPersonales.style.zIndex = 1;

            var popupPosition = document.getElementById("PopUpRegistraDenuncia").offsetTop;

            window.scrollTo({
                top: popupPosition,
                behavior: 'smooth' 
            });

            //Parte label PopUpRegistraDenunucia
            CheckAutorizarData.style.backgroundColor = '#009400';
            CheckAutorizarData.style.border = '1px solid green';

            const ContenerdorMadre = document.getElementById("ContenedorMadre");
            ContenerdorMadre.style.filter = 'blur(2px)';
            
            ButtonSiguientePopUp.style.display= 'block';


            
        } else {
            alert("Esta selección es obligatoria para poder continuar el proceso")
            
            //Parte label PopUpRegistraDenunucia
            CheckAutorizarData.style.backgroundColor = '#fc9989';
            CheckAutorizarData.style.border = '1px solid red';
            LabelCheckAutorizarData.style.color = 'red';
        }
    }

    //Validacion Check RegistarDenuncia
    const handleSeleccionPopUp2 = (opcion) => {
        const ButtonPopUpRegistrarDenuncia = document.getElementById("PopUpregistrarDenuncia");
        const CheckRegistrarDenunciar = document.getElementById("checkboxRegistrarDenuncia")
        const LabelCheckRegistrarDenuncia = document.getElementById("labelColor1");
        const advertenciaLabelRegistrarDenuncia = document.getElementById("LecturaChecks-1");
        setOpcionSeleccionadaPopUp2(opcion);
        //alert(opcion)
        if(opcion === true){
            //Parte label PopUpRegistraDenunucia
            CheckRegistrarDenunciar.style.backgroundColor = '#009400';
            CheckRegistrarDenunciar.style.border = '1px solid green';
            LabelCheckRegistrarDenuncia.style.color = 'green';

            //Parte del Button PopUpRegistraDenunucia 
             ButtonPopUpRegistrarDenuncia.style.display= 'block'

            //Parte Advertebcia label PopUpRegistraDenunucia
            advertenciaLabelRegistrarDenuncia.style.display= 'none'
        }
        else{
            //Parte del Button PopUpRegistraDenunucia
            ButtonPopUpRegistrarDenuncia.style.display='none';

             //Parte Advertebcia label PopUpRegistraDenunucia
            advertenciaLabelRegistrarDenuncia.style.display= 'block'

            //Parte label PopUpRegistraDenunucia
            CheckRegistrarDenunciar.style.backgroundColor = '#fc9989';
            LabelCheckRegistrarDenuncia.style.color = 'red';
        }
    }

    //Oncick Button Siguiente popUpDatosPersonales
    const PopUpRegistroDenuncia = () => {
        const CheckRegistrarDenunciar = document.getElementById("checkboxRegistrarDenuncia")
        const LabelCheckAutorizarData = document.getElementById("labelColor1");
        const ButtonPopUpRegistrarDenuncia = document.getElementById("PopUpregistrarDenuncia");
        if (opcionSeleccionadaPopUp2 === true) {
            //Parte Para Ocultar el popUpDatosPersonales
            OcultarPopUpRegistrarDenuncia.style.display = 'none'

            //Parte label PopUpRegistraDenunucia
            CheckRegistrarDenunciar.style.backgroundColor = '#009400';
            CheckRegistrarDenunciar.style.border = '1px solid green';
            LabelCheckAutorizarData.style.color = 'green';

            ButtonPopUpRegistrarDenuncia.style.display='block';
            
            navigate('/TipoConducta');
        } else {
            alert("Esta selección es obligatoria para poder continuar el proceso")

            //Parte label PopUpRegistraDenunucia
            CheckRegistrarDenunciar.style.backgroundColor = '#fc9989';
            CheckRegistrarDenunciar.style.border = '1px solid red';
            LabelCheckAutorizarData.style.color = 'red';
        }
    }

    const cerrarPopUp = () => {
        const OcultarPopUpRegistrarDenuncia = document.getElementById("PopUpRegistraDenuncia");
        OcultarPopUpRegistrarDenuncia.style.display = 'none'

        const ContenerdorMadre = document.getElementById("ContenedorMadre");
        ContenerdorMadre.style.filter = 'blur(0px)';

        const LabelCheckAutorizarData = document.getElementById("labelColor");
        LabelCheckAutorizarData.style.backgroundColor = 'transparent'
    };


    return (
        <div>
            <Helmet>
                {/*Enacargado de manejar la seguridad CSP*/}
                <meta httpEquiv="Content-Security-Policy" content={
                            `script-src 'self' 'unsafe-inline';
                            media-src 'self'  https://cdn.jsdelivr.net;
                            style-src 'self';
                            report-uri /endpoint-para-informes; 
                            object-src 'self' 'unsafe-inline';
                            font-src https://fonts.googleapis.com;`}/>
                {/*Enacargado de manejar la seguridad Missing Anti-clickjacking Header*/}
                <meta http-equiv="X-Frame-Options" content="SAMEORIGIN"/>
            </Helmet>

            <Header/>
            <form>
                <div id='ContenedorMadre'>
                    <div className='ParteSuperiorContainerMadre'>
                        <h3>Canal Ético de Denuncias</h3>
                        <p>Cafam pone a disposición canal de denuncia, que garantiza
                            total independencia, transparencia, confidencialidad y confiabilidad.
                        </p>
                        <h5>¿Qué es canal ético?</h5>
                        <p>Mecanismo de reporte de carácter reservado donde los colaboradores de Cafam, los afiliados, proveedores
                            o cualquier otro grupo de interés, pueden reportar eventos de incumplimiento a la ética y buen gobierno.</p>
                    </div>

                    <div className='ParteInferiorContainerMadre'>
                        <div className='PhotoContainerMadre'>
                            <img src={canal1} className="App-logo" alt="" /> 
                        </div>
                        <div className='ParteAutorizacionContainerMadre'>
                            <h3>Autorización Tratamiento de Datos Personales</h3>
                            <div className='TextoPopUpAutorizaciónData'>
                                <p>Luego de aceptar la autorización de tratamiento de datos personales, continuará en el canal de denuncia dispuesto por Cafam.</p>
                                <p className='TextoPopUpAutorizacionData'>
                                Consulta la Autorización de tratamiento de datos personales <a href={Autorización_Tratamiento_de_datos_personales_v3} target="_blank" rel="noopener noreferrer" className="Enlances">aquí</a>
                                </p>
                            </div>  
                            <div className='ChecksPopUpAutorizaciónData'>
                                <Form.Check
                                    id='checkboxAutorizarData'
                                    className='checkboxAutorizarData'
                                    type="checkbox"
                                    label={<span id="labelColor">He leído y comprendido las finalidades y autorizo el tratamiento de mis datos personales, de conformidad con 
                                        la política de <a href='https://www.cafam.com.co/experiencia-cliente-cafam/proteccion-datos' target="_blank"  rel="noopener noreferrer" className='Enlances'>Protección Datos Personales</a></span>}
                                    name="CheckPopUpDatosPersonales"
                                    checked={opcionSeleccionadaPopUp1}
                                    onChange={(e) => handleSeleccionPopUp1(e.target.checked)}
                                />
                                <p id='LecturaChecks'>Debe aceptar la lectura y comprensión para poder continuar</p>
                                <Button id='SiguientePopUp' onClick={PopUpDatosPersonales}>Siguiente</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

          {/* PopUpRegistraDenuncia */}
            <form>
                <div id='PopUpRegistraDenuncia'>
                    <div id='corner-button' onClick={cerrarPopUp}>
                        <img src={cerrar} className="cerrarFormularioSICOF" alt="" /> 
                    </div>
                    <div id='ParteSuperiorPopUpRegistraDenuncia'>
                        <h5>REGISTRO DE DENUNCIA</h5>
                    </div>
                    <div className='TextoPopUpRegistraDenuncia'>
                        <p>Luego de aceptar términos y condiciones ingresará al formulario de denuncia dispuesto por Cafam</p>
                        <p>Consulte términos y condiciones <a href='https://assets.ctfassets.net/3klebcd0t2ch/37XBNt43CB94lMr2OCcwQ3/1d87e70c6d475808f87e6396b3b005fa/TYC-CANALETICO-DENUNCIAS.pdf' className='Enlances' rel="noopener noreferrer" target="_blank">aquí</a></p>
                    </div>
                    <div className='ChecksPopUpRegistraDenuncia'>
                        <Form.Check
                            id='checkboxRegistrarDenuncia'
                            className='checkboxRegistrarDenuncia'
                            type="checkbox"
                            label={<span id="labelColor1">Acepto términos y condiciones del canal de denuncia</span>}
                            name="CheckPopUpResgistrarDenuncia"
                            checked={opcionSeleccionadaPopUp2}
                            onChange={(e) => handleSeleccionPopUp2(e.target.checked)}
                        />
                        <p id='LecturaChecks-1'>Debe aceptar la lectura y comprensión para poder continuar</p>
                        <Button id='PopUpregistrarDenuncia' onClick={PopUpRegistroDenuncia}>Siguiente</Button>
                    </div>
                </div>
            </form>
        </div>
    );
}; 

export default IncioSICOF;


